/* Wolki Farm Pantry PDP — interactive layer. */
(function () {
  const root = document.querySelector(".pantry-pdp");
  if (!root) return;
  const data = (() => {
    const el = document.getElementById("pantry-pdp-data");
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch { return {}; }
  })();
  const money = (cents) => {
    const n = Math.round(cents) / 100;
    if (n === Math.floor(n)) return "$" + n;
    return "$" + n.toFixed(2);
  };
  const state = {
    variantId: data.defaultVariantId || (data.variants && data.variants[0] && data.variants[0].id),
    sellingPlanId: null,
    mode: "once",
    bundleQty: data.bundleQty || 4,
    qty: 1,
    cartTotalCents: 0,
  };
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  function getVariant() {
    return (data.variants || []).find(v => String(v.id) === String(state.variantId)) || (data.variants || [])[0];
  }
  function getEffectiveQty() { return state.mode === "bundle" ? state.bundleQty * state.qty : state.qty; }
  function getEffectivePrice() {
    const v = getVariant();
    if (!v) return 0;
    const unit = v.price;
    const qty = getEffectiveQty();
    let multiplier = 1;
    // Subscribe here is a no-discount "restock" plan — price stays full.
    if (state.mode === "bundle" && data.bundleDiscount) multiplier = 1 - data.bundleDiscount;
    return Math.round(unit * qty * multiplier);
  }
  function getFreeShipThreshold() {
    const el = $("[data-free-ship-cents]");
    return el ? parseInt(el.getAttribute("data-free-ship-cents"), 10) || 10000 : 10000;
  }
  function buildFreq() {
    const modes = $(".pp-modes");
    const subBtn = $('.pp-mode[data-mode="sub"]');
    if (!modes || !subBtn || !Array.isArray(data.subPlans) || !data.subPlans.length) return null;
    const badge = subBtn.querySelector(".pp-mode__badge"); if (badge) badge.remove();
    if (!document.getElementById("pp-sub-freq-style")) {
      const st = document.createElement("style");
      st.id = "pp-sub-freq-style";
      st.textContent = ".pp-sub-freq{margin:12px 0 0}.pp-sub-freq[hidden]{display:none}.pp-sub-freq__label{display:block;font-size:12px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:#6b6357;margin:0 0 6px}.pp-sub-freq__select{width:100%;padding:12px 14px;border:1px solid #ddd3c3;border-radius:8px;background:#fffdf8;font-size:15px;font-weight:600;color:#2b2b2b;cursor:pointer}.pp-sub-freq__select:focus{outline:none;border-color:#2f5d3a;box-shadow:0 0 0 3px rgba(47,93,58,.12)}";
      document.head.appendChild(st);
    }
    const defaultPlan = subBtn.getAttribute("data-selling-plan-id");
    const wrap = document.createElement("div"); wrap.className = "pp-sub-freq"; wrap.hidden = true;
    const lbl = document.createElement("label"); lbl.className = "pp-sub-freq__label"; lbl.setAttribute("for", "pp-sub-freq-select"); lbl.textContent = "Delivery frequency";
    const sel = document.createElement("select"); sel.className = "pp-sub-freq__select"; sel.id = "pp-sub-freq-select";
    data.subPlans.forEach(p => {
      const opt = document.createElement("option"); opt.value = p.id; opt.textContent = p.name;
      if (defaultPlan && String(p.id) === String(defaultPlan)) opt.selected = true;
      sel.appendChild(opt);
    });
    wrap.appendChild(lbl); wrap.appendChild(sel);
    modes.insertAdjacentElement("afterend", wrap);
    return sel;
  }
  function render() {
    const v = getVariant();
    if (!v) return;
    const eff = getEffectivePrice();
    const original = v.price * getEffectiveQty();
    const priceEl = $(".pp-buybox__price-value");
    if (priceEl) priceEl.textContent = money(eff);
    const strikeEl = $(".pp-buybox__strike");
    if (strikeEl) {
      if (eff < original) { strikeEl.textContent = money(original); strikeEl.hidden = false; }
      else { strikeEl.hidden = true; }
    }
    const freqEl = $(".pp-sub-freq");
    if (freqEl) freqEl.hidden = (state.mode !== "sub");
    const unitEl = $(".pp-buybox__unit-value"); if (unitEl) unitEl.textContent = v.unitNote || "";
    const afterpayEl = $(".pp-buybox__afterpay-value"); if (afterpayEl) afterpayEl.textContent = money(Math.round(eff / 4));
    $$(".pp-size").forEach(btn => btn.setAttribute("aria-pressed", String(btn.getAttribute("data-variant-id")) === String(state.variantId)));
    $$(".pp-mode").forEach(btn => btn.setAttribute("aria-pressed", btn.getAttribute("data-mode") === state.mode));
    const qtyEl = $(".pp-qty__val"); if (qtyEl) qtyEl.textContent = state.qty;
    const ctaEl = $(".pp-buybox__cta");
    if (ctaEl) {
      const tmpl = ctaEl.getAttribute("data-cta-template") || "Add to cart · %price%";
      ctaEl.querySelector(".pp-btn__label").textContent = tmpl.replace("%price%", money(eff));
    }
    const sPriceEl = $(".pp-sticky__price-value"); if (sPriceEl) sPriceEl.textContent = money(eff);
    const sSubEl = $(".pp-sticky__sub-value");
    if (sSubEl) {
      const sizeBit = v.title && v.title !== "Default Title" ? v.title : "";
      const modeBit = state.mode === "sub" ? " · Subscribe" : state.mode === "bundle" ? " · Stock-up" : "";
      sSubEl.textContent = (sizeBit || "Add to cart") + modeBit;
    }
    const sCtaEl = $(".pp-sticky__cta .pp-btn__label"); if (sCtaEl) sCtaEl.textContent = "Add · " + money(eff);
    renderShipMeter();
  }
  function renderShipMeter() {
    const meter = $("[data-pp-ship]"); if (!meter) return;
    const threshold = getFreeShipThreshold();
    const projected = state.cartTotalCents + getEffectivePrice();
    const remaining = Math.max(0, threshold - projected);
    const pct = Math.min(100, (projected / threshold) * 100);
    const fill = meter.querySelector("[data-pp-ship-fill]");
    const label = meter.querySelector("[data-pp-ship-label]");
    if (fill) fill.style.width = pct + "%";
    if (label) {
      if (remaining <= 0) { label.innerHTML = "<strong>Free shipping unlocked ✓</strong>"; meter.classList.add("is-unlocked"); }
      else { label.innerHTML = "You’re <strong>" + money(remaining) + "</strong> away from free shipping"; meter.classList.remove("is-unlocked"); }
    }
  }
  async function fetchCart() {
    try {
      const r = await fetch("/cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } });
      const cart = await r.json();
      state.cartTotalCents = cart.total_price || 0;
      const badges = document.querySelectorAll("[data-cart-count], .cart-count, .header__cart-count");
      badges.forEach(b => { b.textContent = cart.item_count; });
      renderShipMeter();
      return cart;
    } catch (_) {}
  }
  function wire() {
    const freqSelect = buildFreq();
    $$(".pp-size").forEach(btn => btn.addEventListener("click", () => { state.variantId = btn.getAttribute("data-variant-id"); render(); }));
    $$(".pp-mode").forEach(btn => btn.addEventListener("click", () => {
      state.mode = btn.getAttribute("data-mode");
      if (state.mode === "sub") {
        state.sellingPlanId = (freqSelect && freqSelect.value) || btn.getAttribute("data-selling-plan-id") || null;
      } else {
        state.sellingPlanId = null;
      }
      render();
    }));
    if (freqSelect) freqSelect.addEventListener("change", () => { state.sellingPlanId = freqSelect.value || null; render(); });
    const qPlus = $(".pp-qty__plus"); const qMinus = $(".pp-qty__minus");
    if (qPlus) qPlus.addEventListener("click", () => { state.qty++; render(); });
    if (qMinus) qMinus.addEventListener("click", () => { state.qty = Math.max(1, state.qty - 1); render(); });
    $$(".pp-faq__item").forEach(item => {
      const q = item.querySelector(".pp-faq__q"); if (!q) return;
      q.addEventListener("click", () => {
        const open = item.getAttribute("aria-expanded") === "true";
        $$(".pp-faq__item").forEach(i => i.setAttribute("aria-expanded", "false"));
        item.setAttribute("aria-expanded", open ? "false" : "true");
      });
    });
    const main = $(".pp-gallery__main img");
    $$(".pp-gallery__thumb").forEach(thumb => {
      thumb.addEventListener("click", () => {
        $$(".pp-gallery__thumb").forEach(t => t.setAttribute("aria-selected", "false"));
        thumb.setAttribute("aria-selected", "true");
        const full = thumb.getAttribute("data-full-src");
        if (main && full) main.src = full;
      });
    });
    const ctaBtn = $(".pp-buybox__cta"); const stickyBtn = $(".pp-sticky__cta");
    [ctaBtn, stickyBtn].filter(Boolean).forEach(btn => btn.addEventListener("click", (e) => { e.preventDefault(); addToCart(); }));
    const sentinel = $(".pp-buybox__sentinel"); const sticky = $(".pp-sticky");
    if (sentinel && sticky) {
      const io = new IntersectionObserver((entries) => entries.forEach(e => sticky.classList.toggle("is-visible", e.boundingClientRect.top < 0 && !e.isIntersecting)), { threshold: [0, 1] });
      io.observe(sentinel);
      document.body.classList.add("pantry-pdp-has-sticky");
    }
  }
  async function addToCart() {
    const v = getVariant(); if (!v) return;
    const qty = getEffectiveQty();
    const payload = { items: [{ id: Number(v.id), quantity: qty }] };
    if (state.mode === "sub" && state.sellingPlanId) payload.items[0].selling_plan = Number(state.sellingPlanId);
    try {
      const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(payload) });
      if (!res.ok) throw new Error("add failed");
      await res.json();
      showToast("Added to cart · " + money(getEffectivePrice()));
      await fetchCart();
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (err) {
      console.error("PantryPDP add-to-cart failed", err);
      showToast("Couldn't add — try again");
    }
  }
  let toastTimer = null;
  function showToast(text) {
    const toast = $(".pp-toast"); if (!toast) return;
    toast.querySelector(".pp-toast__label").textContent = text;
    toast.classList.add("is-visible");
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove("is-visible"), 2200);
  }
  wire();
  render();
  fetchCart();
  window.PantryPDP = { state, render, fetchCart };
})();
